module.exports = __webpack_public_path__ + "img/poster-placeholder.584ed720.png";